// extracted by mini-css-extract-plugin
export var width100 = "X_w d_w";
export var design3Pos = "X_x4 d_0";